import { Component } from '@angular/core';
import { ADVISORY_BOOKING_URL } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-final-cta',
  templateUrl: './landing-final-cta.component.html',
  styleUrls: ['./landing-final-cta.component.scss'],
})
export class LandingFinalCtaComponent {
  readonly advisoryBookingUrl = ADVISORY_BOOKING_URL;
}
